




// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const GlobalNews = ({ data }) => {
//     const [newsList, setNewsList] = useState([]);

//     // ⭐ extract sectionTitle + sectionSlug safely
//     const section = data?.[0] || {};
//     const sectionTitle = section.sectionTitle || "";
//     const sectionSlug = section.sectionSlug || "";

//     // ⭐ Convert backend array → flat usable format
//     const mapGlobalNews = (sections = []) => {
//         let finalList = [];

//         sections.forEach((section) => {
//             const items = section.newsItems || [];

//             items.forEach((item) => {
//                 const titles = item.title || [];
//                 const images = item.imageUrl || [];
//                 const categories = item.category || [];
//                 const dates = item.publishDate || [];
//                 const descriptions = item.description || [];
//                 const slugs = item.slug || [];

//                 const maxLen = Math.max(
//                     titles.length,
//                     images.length,
//                     categories.length,
//                     dates.length,
//                     descriptions.length,
//                     slugs.length
//                 );

//                 for (let i = 0; i < maxLen; i++) {
//                     finalList.push({
//                         title: titles[i] || "No Title",
//                         slug: slugs[i] || "",
//                         image: images[i] || "/assets/img/default.jpg",
//                         category: categories[i] || "",
//                         date: dates[i] || "",
//                         description: descriptions[i] || ""
//                     });
//                 }
//             });
//         });

//         return finalList;
//     };

//     useEffect(() => {
//         setNewsList(mapGlobalNews(data || []));
//     }, [data]);

//     return (
//         <section className="global-news-area pt-20 pb-20">
//             <div className="container">

//                 {/* Section Heading */}
//                 <div className="section-title text-center mb-4">
//                     <h2 className="fw-bold">{sectionTitle}</h2>
//                     <p>{sectionSlug}</p>
//                 </div>

//                 {/* News List */}
//                 <div className="row">
//                     {newsList.map((item, index) => (
//                         <div className="col-lg-4 col-md-6 mb-4" key={index}>
//                             <div className="global-card border rounded shadow-sm p-3 hover-card">

//                                 {/* TITLE */}
//                                 <h5 className="fw-bold mb-1">{item.title}</h5>

//                                 {/* SLUG */}
//                                 <p className="text-primary mb-2" style={{ fontSize: "14px" }}>
//                                     {item.slug}
//                                 </p>

//                                 {/* IMAGE */}
//                                 <Link to={`/news/${item.slug || "#"}`}>
//                                     <img
//                                         src={item.image}
//                                         alt="news"
//                                         className="img-fluid rounded"
//                                         style={{
//                                             width: "100%",
//                                             height: "230px",
//                                             objectFit: "cover"
//                                         }}
//                                     />
//                                 </Link>

//                                 {/* CATEGORY */}
//                                 {item.category && (
//                                     <span className="badge bg-dark mt-2">
//                                         {item.category}
//                                     </span>
//                                 )}

//                                 {/* DATE */}
//                                 {item.date && (
//                                     <p className="text-muted mt-1" style={{ fontSize: "14px" }}>
//                                         <i className="fa fa-calendar"></i> {item.date}
//                                     </p>
//                                 )}

//                                 {/* DESCRIPTION */}
//                                 {item.description && (
//                                     <p className="text-muted small">
//                                         {item.description.length > 140
//                                             ? item.description.substring(0, 140) + "..."
//                                             : item.description}
//                                     </p>
//                                 )}

//                                 {/* READ MORE */}
//                                 <Link
//                                     to={`/news/${item.slug}`}
//                                     className="btn btn-outline-primary btn-sm mt-auto"
//                                 >
//                                     Read More →
//                                 </Link>

//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             {/* Hover Style */}
//             <style>{`
//                 .hover-card {
//                     transition: 0.3s ease;
//                 }
//                 .hover-card:hover {
//                     transform: translateY(-5px);
//                     box-shadow: 0 6px 18px rgba(0,0,0,0.15);
//                 }
//             `}</style>
//         </section>
//     );
// };

// export default GlobalNews;














// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';


// const Country = () => {
//   const [data, setData] = useState({});
//   const [loading, setLoading] = useState(true);

//   // Define default static data matching the backend structure
//   const defaultData = {
//     main_news: {
//       featured: {
//         title: "देश की ताज़ा खबरें",
//         category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
//         date: "2017-03-22T22:36",
//         image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
//       },
//       list: [
//         {
//           title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
//           image: "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
//           category: "News",
//           date: "2017-03-22T22:43",
//           description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है। मामले में मध्य प्रदेश सरकार द्वारा बनाई गई SIT की टीम ने बुधवार-गुरुवार की दरमियानी रात तमिलनाडु के...."
//         },
//         {
//           title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
//           image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
//           category: "News",
//           date: "2017-03-22T01:19",
//           description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है। इस मामले में IPS-IAS अफसरों के साथ ही HCS और HPS अफसर भी दो धड़ों में बंटे हैं। एससी वर्ग के अफसर वाई पूरन कुमार को न्याय दिलाने के लिए लामबंद हो रहे हैं।....."
//         },
//         {
//           title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
//           image: "/assets/img/11-1_1759952360.webp",
//           category: "News",
//           date: "2017-03-22T01:19",
//           description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था, यदि जिला प्रशासन नागपुर से मिले अलर्ट को सीरियसली लेता। दरअसल, नागपुर के कलर्स अस्पताल के संचालक डॉ. राजेश अग्रवाल ने 15 सितंबर को ही परासिया के स्थानीय पार्षद अनुज पाटकर को....."
//         }
//       ]
//     },

//   };

//   useEffect(() => {
//     let mounted = true;
//     const fetchData = async () => {
//       try {
//         console.log("Fetching news data...");
//         const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/country/all`);
//         console.log("res : country :",res,res.data)
//         if (!mounted) return;
//         const fetchedData = res.data.data[0] || defaultData;
//         console.log("Fetched news data:", fetchedData);
//         setData(fetchedData);
//       } catch (err) {
//         console.error("Error fetching news:", err);
//         setData(defaultData);
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     };
//     fetchData();
//     return () => {
//       mounted = false;
//     };
//   }, []);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <>
//       <section className="section-space-bottom-less30 mt-lg-5">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-8 col-md-12 mb-30">
//               <div className="topic-border color-cod-gray mb-30">
//                 <div className="topic-box-lg color-cod-gray">{data.main_news?.featured?.title}</div>
//               </div>
//               <div className="img-overlay-70 img-scale-animate">
//                 <img src={data.main_news?.featured?.image} alt="news" className="img-fluid" />
//                 <div className="mask-content-lg">
//                   <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">National News</div>
//                   <div className="post-date-light">
//                     <ul>
//                       <li>
//                         <span>
//                           <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                         </span>{new Date(data.main_news?.featured?.date).toLocaleDateString()}
//                       </li>
//                     </ul>
//                   </div>
//                   <h2 className="title-medium-light size-xl d-none d-sm-block">
//                     <Link to="/news_info">{data.main_news?.featured?.category}</Link>
//                   </h2>
//                 </div>
//               </div>
//               <div className="item-box-light-md-less30 ie-full-width">
//                 {data.main_news?.list?.map((item, index) => (
//                   <div key={index} className="media mb-30 media-none--sm">
//                     <div className="position-relative width-40">
//                       <Link to="/news_info" className="img-opacity-hover">
//                         <img src={item.image} alt="news" className="img-fluid" />
//                       </Link>
//                       <div className="topic-box-top-xs">
//                         <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
//                       </div>
//                     </div>
//                     <div className="media-body p-mb-none-child media-margin30">
//                       <div className="post-date-dark">
//                         <ul>
//                           <li>
//                             <span>
//                               <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                             </span>{new Date(item.date).toLocaleDateString()}
//                           </li>
//                         </ul>
//                       </div>
//                       <h3 className="title-semibold-dark size-lg mb-15 mb5-md">
//                         <Link to="/news_info">{item.title}</Link>
//                       </h3>
//                       <p>{item.description}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Country;




import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Country = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  // ---------- DEFAULT STATIC DATA ----------
  const defaultData = {
    main_news: {
      featured: {
        title: "देश की ताज़ा खबरें",
        category:
          "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार...",
        date: "2017-03-22T22:36",
        // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp",
        image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
      },

      list: [
        {
          title:
            "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
          // image:
          //   "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
          category: "News",
          date: "2017-03-22T22:43",
          description:
            "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप...",
        },
        {
          title:
            "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
          // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
          category: "News",
          date: "2017-03-22T01:19",
          description:
            "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल...",
        },
        {
          title:
            "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
          // image: "/assets/img/11-1_1759952360.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
          category: "News",
          date: "2017-03-22T01:19",
          description:
            "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला...",
        },
      ],
    },
  };

  // ---------- FETCH DATA ----------
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/country/all`
        );
        if (!mounted) return;

        const fetchedData = res?.data?.data?.[0] || defaultData;
        setData(fetchedData);
      } catch (err) {
        console.log("Fetch error:", err);
        setData(defaultData);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();
    return () => (mounted = false);
  }, []);

  if (loading) return <div>Loading...</div>;

  const featured = data.main_news?.featured;
  const list = data.main_news?.list || [];

  return (
    <section className="section-space-bottom-less30 mt-lg-5">
      <div className="container">
        <div className="topic-border color-cod-gray mb-30">
          <div className="topic-box-lg color-cod-gray">
            {featured?.title}
          </div>
        </div>

        {/* ---------- FEATURED TOP NEWS ---------- */}
        <div className="featured-news-card mb-5">
          <img
            src={
              Array.isArray(featured?.image)
                ? featured.image[0]
                : featured?.image
            }
            alt="featured"
            className="featured-image"
            onError={(e) => (e.target.src = "/assets/img/placeholder.jpg")}
          />

          <div className="featured-overlay">
            <span className="cat-badge">{featured?.title}</span>

            <h1 className="featured-title">
              <Link to="/news_info">{featured?.category}</Link>
            </h1>

            <p className="featured-date" style={{ color: "white", fontSize: "16px", fontFamily: "sans-serif" }}>
              <i className="fa fa-calendar" style={{ color: "white", margin: "10px" }}></i>{" "}
              {new Date(featured?.date).toLocaleDateString()}
            </p>

            <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
            <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
            <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />

          </div>
        </div>

        {/* ---------- NEWS LIST ---------- */}
        <div className="row" style={{marginTop:"40px"}}>
          {list.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="news-card">
                <Link to="/news_info">
                  <img
                    src={
                      Array.isArray(item.image) ? item.image[0] : item.image
                    }
                    alt="news"
                    className="news-img"
                    onError={(e) =>
                      (e.target.src = "/assets/img/placeholder.jpg")
                    }
                  />
                </Link>

                <div className="news-content">
                  <span className="news-cat">{item.category}</span>

                  <h3 className="news-title">
                    <Link to="/news_info">{item.title}</Link>
                  </h3>

                  <p className="news-desc">{item.description}</p>

                  <p className="news-date" style={{ color: "black", fontSize: "16px", fontFamily: "sans-serif" }}>
                    <i className="fa fa-calendar" style={{ color: "black", margin: "10px" }}></i>
                    {new Date(item.date).toLocaleDateString()}
                  </p>

                  <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black" }} />
                  <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                  <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Country;

